<!-- 客户管理 - 客户列表 - 供应产品 按钮  -->
<template>
  <div>
    <el-row style="margin-bottom: -20px;">
      <h4>客户名称：{{ customerName }}</h4>
    </el-row>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true" style="margin-top:20px">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" v-model="searchForm.code" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="querySearch">筛选</el-button>
            <el-button size="medium" @click="upData" v-show="customerStatus !== 1">上架</el-button>
            <el-button size="medium" @click="openImportDialog(0)" v-if="!(customerStatus == 1 && userPriceType == 1)">
              批量导入
            </el-button>
            <el-button size="medium" @click="openImportDialog(1)" v-if="Number(this.userPriceType) !== 2 && customerStatus !== 1">
              含税销售价导入
            </el-button>
            <!-- <el-button size="medium" @click="batchDownShelf" v-show="customerStatus !== 1 && userPriceType == 2">批量下架</el-button> -->
            <el-button size="medium" @click="batchDownShelf" v-show="customerStatus !== 1">批量下架</el-button>
            <el-button size="medium" type="primary" plain @click="openExportData" v-show="userPriceType == 2">导出价格</el-button>
            <el-button size="medium" type="primary" plain @click="打开导出全部价格模态框()">导出全部价格</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column label="序号" type="index" width="80"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="产品名称" prop="PRODUCT_NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="当前价格" prop="CURRENT_PRICE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="当前不含税价格" prop="CURRENT_BEFORE_TAX_PRICE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="下期价格" prop="NEXT_PRICE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="下期不含税价格" prop="NEXT_BEFORE_TAX_PRICE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="下期生效日期" prop="NEXT_EFFECTIVE_DATE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="价格" prop="PRICE" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="不含税价格" prop="BEFORE_TAX_PRICE" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="开始日期" prop="START_DAY" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="结束日期" prop="END_DAY" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="销售价变化比例" prop="SALE_PRICE_CHANGE_RATE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="当期最低采购价" prop="CURRENT_MIN_PRICE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="下期最低采购价" prop="NEXT_MIN_PRICE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="采购价变化比例" prop="PURCHASE_PRICE_CHANGE_RATE" v-if="userPriceType == 1">
          </el-table-column>
          <el-table-column label="操作" v-if="customerStatus !== 1">
            <template slot-scope="scope">
              <el-button type="text" @click="updateData(scope.row)">修改</el-button>
              <el-button type="text" @click="downData(scope.row)" v-if="tcStatus === 1 && userPriceType == 1" disabled>
                下架</el-button>
              <el-button type="text" @click="downData(scope.row)" v-if="userPriceType == 1">下架</el-button>
              <el-button type="text" @click="delData(scope.row)" v-if="userPriceType == 2">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount"
          @current-change="handleCurrentChange"></el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="修改" center :visible.sync="editFormVisible" width="500px">
      <el-form :model="editForm" ref="editForm" style="margin-top: 0">
        <div v-if="userPriceType == 1">
          <el-form-item label="价格：" :label-width="formLabelWidth" prop="leader">
            <label slot="label">价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格：</label>
            <el-input v-model="editForm.CURRENT_PRICE" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth">
            <label slot="label">生效日期：</label>
            <el-date-picker v-model="editForm.SEND_DAY" :clearable="false" :picker-options="pickerOptions" type="date" placeholder="选择日期"
              style="width: 100%">
            </el-date-picker>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="价格：" :label-width="formLabelWidth" prop="leader">
            <label slot="label">价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格：</label>
            <el-input v-model="editForm.PRICE" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth">
            <label slot="label">开始日期：</label>
            <el-date-picker v-model="editForm.START_DAY" :clearable="false" :picker-options="pickerOptions" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 100%">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth">
            <label slot="label">结束日期：</label>
            <el-date-picker v-model="editForm.END_DAY" :clearable="false" :picker-options="pickerOptions" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 100%">
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('editForm')">取 消</el-button>
        <el-button @click="submitAdd('editForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量导入" center :visible.sync="importPriceDialog" width="400px">
      <el-form :inline="true" :model="importPriceForm" ref="importPriceForm" style="margin-top: 0">
        <el-form-item label="生效日期：" v-if="userPriceType == 1">
          <el-date-picker v-model="importPriceForm.EFFECTIVE_DATE" align="right" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            :picker-options="pickerOptions1" style="width:100%">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="按斤/公斤导入">
          <el-radio-group v-model="importPriceForm.是否使用斤">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="上传文件：">
          <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
            :on-remove="handleRemove" :name="this.importPriceForm.file" multiple :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <p @click="downloadTmp()" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeImport()">取消</el-button>
        <el-button @click="submitImport()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导出价格 -->
    <el-dialog :visible.sync="exportTableDialog" @close="exportTableDialog = false" title="导出价格" width="500px" center>
      <el-form ref="outExportForm" v-model="outExportForm" label-width="120px">

        <el-form-item  label="日期范围：">
        <el-date-picker style="width: 300px" v-model="outExportForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
          :clearable="false"></el-date-picker>
        </el-form-item>

        <el-form-item label="使用单位：">
          <el-radio-group v-model="EXPORT_UNIT_KG">
            <el-radio label="0">斤</el-radio>
            <el-radio label="1">KG</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="exportTableDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="exportData">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="导出价格选择单位模态框" @close="导出价格选择单位模态框 = false" title="导出价格" width="500px" center>
      <span>导出单位：
        <el-radio-group v-model="EXPORT_UNIT_KG">
          <el-radio label="0">斤</el-radio>
          <el-radio label="1">KG</el-radio>
        </el-radio-group>
      </span>

      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="导出价格选择单位模态框 = false">取消</el-button>
        <el-button v-if="导出类型 == '导出价格'" class="operate-btn" @click="exportData">确认</el-button>
        <el-button v-else class="operate-btn" @click="exportPrice">确认</el-button>

      </div>
    </el-dialog>

    <!-- 顶部的批量下架导入 -->
    <el-dialog title="批量下架" center :visible.sync="batchDownShelfFormVisible" width="400px" :close-on-click-modal="false">
      <el-form size="small" ref="batchDownShelfForm" :model="batchDownShelfForm" style="padding-left: 30px;">
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove"
          :name="this.batchDownShelfForm.file" multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
        </el-upload>
        <el-form-item>
          <span @click="downLoadBatchDownShelfTemp" style="color:#409EFF">点此下载导入模板</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('batchDownShelfForm')">取 消</el-button>
        <el-button size="small" @click="submitBatchDownShelf('batchDownShelfForm')" :loading="loading2">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { unitManageFun } from 'api/systemSetting';
import http from '@/assets/common/http';
import date from '@/assets/common/date';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      导出类型: '',
      导出价格选择单位模态框: false,
      editFormVisible: false,
      editForm: {
        SEND_DAY: new Date(),
      },
      pickerOptions: {
        disabledDate(time) {
          const nowD = new Date();
          return time.getTime() < nowD.getTime() - 3600 * 24 * 1000;
        },
      },
      formLabelWidth: '100px',
      searchForm: {},
      tableData: [],
      currentPage: 1,
      pageSize: 15,
      totalCount: 0,
      tcStatus: 0,
      pickerStatus: true,
      importPriceDialog: false,
      importPriceForm: {
        是否使用斤: 1,
        file: 'supplierPrice',
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now();// 如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      fileList: [],
      customerStatus: Number(sessionStorage.getItem('customerStatus')),
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      exportTableDialog: false,
      outExportForm: {},
      EXPORT_UNIT_KG: '1',
      batchDownShelfFormVisible: false,
      batchDownShelfForm: {
        file: 'tmp',
      },
      loading2: false,
      customerName: sessionStorage.getItem('customerName') || '',
    };
  },
  methods: {
    // ---------------------上架
    upData() {
      this.$router.push({ name: 'addProductsList' });
    },
    // -----------------------修改
    updateData(row) {
      this.editFormVisible = true;
      this.editForm = row;
      // this.editForm.SEND_DAY = new Date()
    },
    submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10041',
            OTYPE: 11,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            TC_ID: Number(sessionStorage.getItem('TC_ID')),
            PRODUCT_CODE: this.editForm.PRODUCT_CODE,
            EFFECTIVE_DAY: date(this.editForm.SEND_DAY, '%F'),
            PRICE_MODE: this.userPriceType,
          };
          if (this.userPriceType == 2) {
            if (validation.价格正数0验证(this.editForm.PRICE)) {
              params.START_DAY = this.editForm.START_DAY;
              params.END_DAY = this.editForm.END_DAY;
              params.TC_PRODUCT_CODE = this.editForm.TC_PRODUCT_CODE;
              params.CHANGE_RATE = this.editForm.CHANGE_RATE;
              params.DETAIL_ID = this.editForm.ID;
              params.PRICE = Number(this.editForm.PRICE);
            } else {
              this.$message.show({ text: '请输入正确的价格', type: 'warning' });
            }
          } else {
            if (validation.价格正数0验证(this.editForm.CURRENT_PRICE)) {
              params.PRICE = Number(this.editForm.CURRENT_PRICE);
            } else {
              this.$message.show({ text: '请输入正确的价格', type: 'warning' });
            }
          }
          http.post(params)
            .then((result) => {
              this.queryTable();
              this.editFormVisible = false;
              this.$message.show({ text: '修改成功', type: 'success' });
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally { }
      }
    },
    close() {
      this.editFormVisible = false;
      this.batchDownShelfFormVisible = false;
    },
    downData(row) {
      this.$confirm('确定下架吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10041',
          OTYPE: 8,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          TC_ID: Number(sessionStorage.getItem('TC_ID')),
          PRODUCT_CODE: row.PRODUCT_CODE,
          DETAIL_ID: row.ID,
        };
        http.post(params)
          .then((result) => {
            this.$message.show({ text: '下架成功', type: 'success' });
            this.queryTable();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ text: '操作取消', type: 'info' });
      });
    },
    queryTable() {
      if (!validation.产品编码验证(this.searchForm.code)) {
        this.$message.show({ text: '产品编码输入有误', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10041',
        OTYPE: 7,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        TC_ID: Number(sessionStorage.getItem('TC_ID')),
        PRICE_MODE: this.userPriceType,
      };
      if (this.searchForm.code) {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      http.post(params).then((result) => {
        if (result.length === 0) {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        } else {
          this.tableData = result[0].LIST.map((item) => ({
            ...item,
            CURRENT_BEFORE_TAX_PRICE: item.CURRENT_BEFORE_TAX_PRICE ? Number(item.CURRENT_BEFORE_TAX_PRICE).toFixed(2) : 0,
            NEXT_BEFORE_TAX_PRICE: item.NEXT_BEFORE_TAX_PRICE ? Number(item.NEXT_BEFORE_TAX_PRICE).toFixed(2) : 0,
            BEFORE_TAX_PRICE: item.BEFORE_TAX_PRICE ? Number(item.BEFORE_TAX_PRICE).toFixed(2) : 0,
          }));
          this.tcStatus = result[0].TC_STATUS;
          this.totalCount = result[0].TOTAL_COUNT;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySearch() {
      this.currentPage = 1;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    openImportDialog(flag) {
      this.importPriceDialog = true;
      this.importPriceForm.includeTax = flag == 1;
      this.importPriceForm.是否使用斤 = this.EXPORT_UNIT_KG;
    },
    closeImport() {
      this.importPriceDialog = false;
    },
    submitImport() {
      if (!this.url) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          // this.loading = true
          const params = {
            SERVICE_ID: '10045',
            OTYPE: this.importPriceForm.includeTax ? 39 : 26,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            FILE_NAME: this.url,
            isSecondOn: 1,
            isOnSale: 1,
            TC_ID: Number(sessionStorage.getItem('TC_ID')),
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            PRICE_MODE: this.userPriceType,
            USER_JIN: this.importPriceForm.是否使用斤,
          };
          if (this.userPriceType == 1) {
            params.EFFECTIVE_DATE = this.importPriceForm.EFFECTIVE_DATE;
          }
          http.post(params).then((result) => {
            // this.$message.show({ text: '导入成功', type: 'success' });
            this.importPriceDialog = false;
            if (result[0] && result[0].FILE_PATH !== '') {
              this.$message.show({ text: '部分导入失败，请注意下载文件', type: 'error' });
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            } else {
              this.$message.show({ text: '导入成功', type: 'success' });
            }
            // this.loading = false
            this.fileList = [];
            this.url = '';
            this.$refs.upload.clearFiles();
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.fileList = [];
            this.url = '';
            this.$refs.upload.clearFiles();
            // this.loading = false
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.url = '';
    },
    打开导出全部价格模态框() {
      this.导出类型 = '导出全部价格';
      this.导出价格选择单位模态框 = true;
    },
    openExportData() {
      if (this.userPriceType == 1) {
        this.导出价格选择单位模态框 = true;

        this.导出类型 = '导出价格';
        // this.exportData();
      } else {
        this.exportTableDialog = true;
      }
    },
    // 导出
    exportData() {
      const params = {
        SERVICE_ID: '10041',
        OTYPE: 14,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        TC_ID: Number(sessionStorage.getItem('TC_ID')),
        PRICE_MODE: this.userPriceType,
        EXPORT_UNIT_KG: this.EXPORT_UNIT_KG,
      };
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.userPriceType == 2) {
        if (this.outExportForm.DAY_INTERVAL) {
          params.START_DAY = this.outExportForm.DAY_INTERVAL[0];
          params.END_DAY = this.outExportForm.DAY_INTERVAL[1];
        } else {
          this.$message.show({ text: '请选择日期', type: 'error' });
        }
      }
      http.post(params)
        .then((result) => {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    downloadTmp() {
      if (this.userPriceType == 2) {
        window.location.href = this.$util.getURLLocalHost('/file/templates/pm2tcpriceTemp.xls');
      } else {
        if (this.importPriceForm.includeTax) {
          window.location.href = this.$util.getURLLocalHost('/file/templates/exportCustomerPriceIncludeTax.xlsx');
        } else {
          window.location.href = this.$util.getURLLocalHost('/file/templates/exportCustomerPrice.xls');
        }
      }
    },
    downLoadBatchDownShelfTemp() {
      if (this.userPriceType == 2) {
        window.location.href = 'https://service.linkda.com.cn/file/templates/pm2nosaleproducts.xlsx';
      } else {
        window.location.href = 'https://service.linkda.com.cn/file/templates/pm1removeCustomerProductsInBatchesTemplate.xls';
      }
    },
    // 批量下架
    batchDownShelf() {
      this.batchDownShelfFormVisible = true;
    },
    submitBatchDownShelf() {
      const params = {
        TC_ID: Number(sessionStorage.getItem('TC_ID')),
        FILE_NAME: this.url,
        SERVICE_ID: '10041',
        OTYPE: 29,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
      };
      this.loading2 = true;
      http.post(params)
        .then((result) => {
          if (result[0].FILE_PATH == '') {
            this.$message.show({ text: '下架成功', type: 'success' });
          } else {
            this.$message.show({ text: '部分下架失败，请注意下载文件', type: 'error' });
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          }
          this.queryTable();
          this.batchDownShelfFormVisible = false;
          this.loading2 = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.loading2 = false;
        });
    },
    delData(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10041',
          OTYPE: 32,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          TC_ID: Number(sessionStorage.getItem('TC_ID')),
          DETAIL_ID: row.ID,
          PRODUCT_CODE: row.PRODUCT_CODE,
          START_DAY: row.START_DAY,
          END_DAY: row.END_DAY,
        };
        http.post(params)
          .then((result) => {
            this.$message.show({ text: '下架成功', type: 'success' });
            this.queryTable();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ text: '操作取消', type: 'info' });
      });
    },
    获取当前供应商使用单位() {
      unitManageFun().then((result) => {
        this.EXPORT_UNIT_KG = result[0].USE_KG.toString();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导出价格
    exportPrice() {
      let params;
      if (this.userPriceType == 1) {
        params = {
          SERVICE_ID: '10041',
          OTYPE: 34,
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          TC_ID: Number(sessionStorage.getItem('TC_ID')),
          EXPORT_UNIT_KG: this.EXPORT_UNIT_KG,
        };
      } else {
        params = {
          SERVICE_ID: '10041',
          OTYPE: 35,
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          TC_ID: Number(sessionStorage.getItem('TC_ID')),
          EXPORT_UNIT_KG: this.EXPORT_UNIT_KG,
        };
      }
      http.post(params).then((res) => {
        if (res[0]) {
          window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
    this.获取当前供应商使用单位();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/customerManage/queryProducts.vue